import { isNewStudio } from "./idTypeChecker";

export const getStudioUrl = (buildID: string) => {
  // New studio
  if (isNewStudio(buildID)) {
    return `https://create.gumgum.com/preview/${buildID}`;
  }
  // Old studio
  return `https://studio.playgroundxyz.com/${buildID}`;
};
